import { Button, FieldBlock, Modal, Textarea } from '@orbind/ui'
import { useEffect, useState } from 'react'

/**
 * Motivo da REABERTURA, pedido ao desmarcar (ou marcar) um checkbox da trilha
 * que tira o item de um status terminal (SPEC-20261007-2155-trilha-de-etapas-e-status).
 *
 * Reabrir exige motivo (spec 13.8). Na trilha não há onde escrevê-lo, então o
 * servidor diz que falta, e este modal pede o texto e confirma — sem ele, nada
 * muda. A etapa não é escolhida aqui: ela é a que o próprio checkbox indicou.
 */
export function MotivoDaReabertura({
  aberto,
  codigo,
  statusDestino,
  salvando,
  onFechar,
  onConfirmar,
}: {
  aberto: boolean
  /** Código do item, para a pessoa saber qual está reabrindo. */
  codigo: string
  /** Para qual status o item volta, quando o servidor informou. */
  statusDestino: string | null
  salvando: boolean
  onFechar: () => void
  onConfirmar: (motivo: string) => void
}) {
  const [motivo, setMotivo] = useState('')
  // cada pedido começa em branco
  useEffect(() => {
    if (aberto) setMotivo('')
  }, [aberto])

  const valido = motivo.trim() !== ''
  return (
    <Modal
      open={aberto}
      onClose={onFechar}
      title={`Reabrir ${codigo}`}
      footer={
        <>
          <Button variant="ghost" onClick={onFechar} disabled={salvando}>
            Cancelar
          </Button>
          <Button variant="primary" loading={salvando} disabled={!valido} onClick={() => onConfirmar(motivo.trim())}>
            Reabrir
          </Button>
        </>
      }
    >
      <FieldBlock
        label="Motivo da reabertura"
        required
        hint={
          statusDestino
            ? `O item sai do status concluído e volta para “${statusDestino}”.`
            : 'O item sai do status concluído.'
        }
      >
        {({ id }) => (
          <Textarea
            id={id}
            rows={4}
            autoFocus
            maxLength={2000}
            placeholder="Por que este item está sendo reaberto?"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
          />
        )}
      </FieldBlock>
    </Modal>
  )
}
